import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import Store from './store';

function Footer({ store }) {
  store.use();

  return <div id="OMNI__COMMON__FOOTER" className="OMNI__COMMON__FOOTER" />;
}
export default wrapStore(Footer, Store);
